import { render, staticRenderFns } from "./SpecimensDs.vue?vue&type=template&id=a3212ef0&scoped=true"
import script from "./SpecimensDs.vue?vue&type=script&lang=js"
export * from "./SpecimensDs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3212ef0",
  null
  
)

export default component.exports